import type { ResolveTeamsResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useCreateUserResolveTeams() {
  return useQuery({
    queryFn: () =>
      apiClient
        .url(`/users/create/resolve-teams`)
        .get()
        .json<ResolveTeamsResponse>(),
    queryKey: ["resolve-teams"],
  });
}
